import React from "react";
import { formatNumber } from "@SeemplicityDev/shared";
import useAddRef, { UseAddRefOptions } from "../useAddRef";
import Seema from "../../Assets/Common/seema-face.svg";
import SeemaHand from "../../Assets/Common/seema-hand.svg";
import Man from "../../Assets/Common/man.svg";

interface TotalAutomationsPageProps extends UseAddRefOptions {
  data?: {
    ticketing_automations: {
      total_count: number;
      total_tickets_count: number;
    };
    reporting_automations?: {
      total_count: number;
    };
    total_closed_tickets_count: number;
  };
}

const TotalAutomationsPage: React.FC<TotalAutomationsPageProps> = ({
  data,
  addRef,
  index,
}) => {
  const ref = useAddRef({ addRef });
  const {
    ticketing_automations,
    reporting_automations,
    total_closed_tickets_count,
  } = data || {};
  return (
    <div className={`eoy-page total-automations-page`} ref={ref}>
      <h3>Automations</h3>
      <h4>
        <span className="main">Scaling Remediation with Automations</span>
      </h4>
      <div className="automations-container">
        <div className="automation-type ticketing-automations-type">
          <span className="automation-type-title">Ticketing Automations |</span>
          <div className="automation-type-count">
            {formatNumber(ticketing_automations?.total_count) || 0}{" "}
            <span>queues generated</span>{" "}
            {formatNumber(ticketing_automations?.total_tickets_count) || 0}{" "}
            <span>tickets</span>
          </div>
        </div>
        {!!reporting_automations && (
          <div className="automation-type reporting-automations-type">
            <span className="automation-type-title">
              Reporting Automations |
            </span>
            <div className="automation-type-count">
              {formatNumber(reporting_automations?.total_count) || 0}{" "}
              <span>configured queues </span>
            </div>
          </div>
        )}
      </div>
      <div className="seema-men-count-container">
        <img src={Seema} alt="seema" className="seema-face" />
        <img src={SeemaHand} alt="seema hand" className="seema-hand" />
        <span className="subtitle">Did you know?</span>
        <div className="left-side">
          {!!total_closed_tickets_count && total_closed_tickets_count > 200 ? (
            <>
              <span className="title">
                {total_closed_tickets_count
                  ? formatNumber(Math.ceil(total_closed_tickets_count * 0.5))
                  : 0}{" "}
                Hours
              </span>
              <p className="description">
                of employees' time <span>was saved{`\n`}</span>by Seemplicity
                Automations
              </p>
            </>
          ) : (
            <p className="description">
              More Seemplicity Automations{`\n`} can{" "}
              <span>boost efficiency{`\n`}</span>
              and <span>save valuable time</span>
            </p>
          )}
        </div>
        <div className="right-side">
          {Array.from({ length: 100 }).map((_, index) => (
            <img src={Man} alt="man" className="man" key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TotalAutomationsPage;
